import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.onscroll = function() {myFunction()};

    let header = this.element;
    let sticky = header.offsetTop+210;

    // console.log(header.offsetTop);
    // console.log(sticky);

    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky2");
      } else {
        header.classList.remove("sticky2");
      }
    }
  }
}